import { render, staticRenderFns } from "./MetricsTable.vue?vue&type=template&id=2f6e3411&"
import script from "./MetricsTable.vue?vue&type=script&lang=js&"
export * from "./MetricsTable.vue?vue&type=script&lang=js&"
import style0 from "./MetricsTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MetricsTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports